export default [
  {
    path: '/head-of-operations',
    name: 'head-of-operations',
    component: () => import('@/views/halal/head-of-operations/HeadOfOperations.vue'),
    meta: {
      title: 'Head of operations / CE',
      requiresAuth: true,
      action: 'browes',
      resource: 'Head of operations / CE',
      pageTitle: 'Head of operations / CE',
      breadcrumb: [
        {
          text: 'Head of operations / CE',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
]
